module.exports = __webpack_public_path__ + "img/4.f9bb81c1.png";